import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { BaseInputDirective } from '../base-input.directive';
import { ErrorDefinition } from '../../models/error-definition';

@Component({
  selector: 'app-toggle-input',
  templateUrl: './toggle-input.component.html',
  styleUrls: ['./toggle-input.component.css'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ToggleInputComponent extends BaseInputDirective implements OnInit {


  ngOnInit() {
    super.ngOnInit();

    this.formControl.patchValue(false);
  }

  getErrorDefinitions(): ErrorDefinition[] {
    return this.errorService.getGenericBoolErrors(this.formControl, this.fgInfo);
  }
}
